import React from 'react';
import i18n from './i18n';

export default class Dropdown extends React.PureComponent {
    render() {
      return (
        <div className="pvtDropdown" style={{zIndex: this.props.zIndex}}>
          <div
            onClick={e => {
              e.stopPropagation();
              this.props.toggle();
            }}
            className={
              'pvtDropdownValue pvtDropdownCurrent ' +
              (this.props.open ? 'pvtDropdownCurrentOpen' : '')
            }
            role="button"
          >
            <div className="pvtDropdownIcon">{this.props.open ? '×' : '▾'}</div>
            {i18n.getMessage(this.props.current) || <span>&nbsp;</span>}
          </div>
  
          {this.props.open && (
            <div className="pvtDropdownMenu">
              {this.props.values.map(r => (
                <div
                  key={r}
                  role="button"
                  onClick={e => {
                    e.stopPropagation();
                    if (this.props.current === r) {
                      this.props.toggle();
                    } else {
                      this.props.setValue(r);
                    }
                  }}
                  className={
                    'pvtDropdownValue ' +
                    (r === this.props.current ? 'pvtDropdownActiveValue' : '')
                  }
                >
                  {i18n.getMessage(r)}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }
  }